import React from "react";
import "./DataAnalytics.css";
import Image from "../../assets/Image";

const services = [
  {
    title: "Data Engineering",
    heading: "Build a Strong Foundation with Scalable Data Architecture",
    points: [
      "Designing simple, scalable data pipelines for structured processing",
      "Supporting data ingestion, transformation, and storage workflows",
      "Exploring cloud-based data warehousing (Snowflake, Redshift, BigQuery)",
      "Laying the foundation for analytics and AI readiness"
    ],
    image: Image.DataEngineering,
  },
  {
    title: "Business Analytics & Visualization",
    heading: "Transform Raw Data into Actionable Insights",
    points: [
      "Creating interactive dashboards with tools like Power BI and Tableau",
      "Building custom reports to track performance and KPIs",
      "Helping stakeholders understand key trends visually",
      "Supporting better decision-making through meaningful visualizations"
    ],
    image: Image.BusinessAnalytVisualization,
  },
  {
    title: "Data Migration Services",
    heading: "Seamless Transition of Your Data with Minimal Disruption",
    points: [
      "Migrating data from spreadsheets, legacy systems, or outdated platforms",
      "Supporting transitions to modern, cloud-native databases",
      "Maintaining data accuracy, integrity, and format during migration",
      "Reducing business downtime with well-planned migrations"
    ],
    image: Image.DataMigrationServices,
  },
  {
    title: "Data Modernization",
    heading: "Modernize Legacy Systems for Future-Ready Intelligence",
    points: [
      "Assessing and upgrading existing data architectures",
      "Moving from on-prem to cloud or hybrid platforms",
      "Supporting API-based and microservice-driven data systems",
      "Preparing systems for advanced analytics and automation"
    ],
    image: Image.DataModernization,
  },
  {
    title: "Data Governance",
    heading: "Ensure Accuracy, Compliance, & Trust in Your Data",
    points: [
      "Promoting data quality and traceability from the start",
      "Beginning implementation of role-based access and usage policies",
      "Introducing metadata management and basic lineage tracking",
      "Aligning with compliance standards as we grow (GDPR, HIPAA, etc.)"
    ],
    image: Image.DataGovernance,
  },
  {
    title: "Data Streaming",
    heading: "Real-Time Data for Real-Time Decisions",
    points: [
      "Exploring real-time data flow using Apache Kafka and Spark",
      "Supporting initial implementations of event-driven architectures",
      "Creating basic pipelines for continuous data updates",
      "Ideal for early adopters of real-time dashboards and alerts"
    ],
    image: Image.DataStreaming,
  },
  {
    title: "Data Annotation & Labelling",
    heading: "High-Quality Labelled Data for Accurate AI/ML Models",
    points: [
      "Offering human-in-the-loop data annotation services",
      "Handling images, videos, text, and audio for ML datasets",
      "Ensuring labelling consistency with multi-layer QA",
      "Great for AI/ML proof-of-concept and research prototypes"
    ],
    image: Image.DataAnnotationLabelling,
  },
];

const DataAnalytics = () => {
  return (
    <div className="analytics-container">
      {/* <br /><br /><br /><br />*/}
      {/* <div className="banner-wrapper">
        <img src={Image.datamigration} alt="Data Migration Banner" className="banner-image" />
        <div className="banner-text">
          Service
          <div className="banner-subtext">Data & Analytics</div>
        </div>
      </div> */}


<section className="appservices-section d-flex">
        <div className="appservices-body">
          <div className="appservices-text">
            <h1>Services</h1>
             <p>
              <span>Data & Analytics</span>
            </p>
          </div>
        </div>
      </section>
      <br /><br /> <br /><br /> 
      <div className="analytics-grid">
        {services.map((service, idx) => (
<div className="card" key={idx}>
  <div className="top-section">
    <img src={service.image} alt={`${service.title} visual`} className="card-image" />
    <div className="title-heading">
      <h4>{service.title}</h4>
      <p className="subheading">{service.heading}</p>
      <hr/>
    </div>
  </div>
<ul>
  {service.points.map((point, index) => (
<li key={index} className="list-item">
  <img src={Image.arrow} alt="arrow" className="arrow-icon" />
  {point}
</li>

  ))}
</ul>

</div>




        ))}
      </div>
    </div>
  );
};

export default DataAnalytics;


//  is code mai her li ke aage arrow naam ki image show hona chaiye  